// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Radio from 'common/domain/radio';
import Permissions from './Permissions';
import getRouteForPermission from './PermissionDefaultRoutes';
import RadioUser from '../../domain/RadioUser';
import { getRadio } from '../authentication/session/reducers/sessionReducer';

type Props = {
  radio: Radio,
  radioUser: RadioUser,
  isAuthenticated: boolean,
};

function DefaultRouteRedirect({ isAuthenticated, radioUser, radio }: Props) {
  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  if (radioUser) {
    if (radioUser.getPermissions().length > 0) {
      if (radioUser.hasPermission(Permissions.ACCESS_DASHBOARD)) {
        return <Redirect to={getRouteForPermission(Permissions.ACCESS_DASHBOARD, radio)} />;
      }

      if (radioUser.hasPermission(Permissions.ACCESS_SALES)) {
        return <Redirect to={getRouteForPermission(Permissions.ACCESS_SALES, radio)} />;
      }

      return <Redirect to={getRouteForPermission(radioUser.getPermissions()[0], radio)} />;
    }

    return <Redirect to="/no-permissions" />;
  }

  return <Redirect to="/select-radio" />;
}

export default connect(
  state => ({
    radio: getRadio(state),
    radioUser: state.session.radioUser,
    isAuthenticated: state.session.isAuthenticated,
  }),
)(DefaultRouteRedirect);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authorisation/DefaultRouteRedirect.js